import u from "jquery";

export class Form {
  static init() {
    u('body').on('click', '.btn-form-open', e => {
      e.preventDefault();
      u('#form-contact').addClass('show');
    });

    // u('.btn-form-open').eq(0).trigger('click');

    u('.btn-close', '#form-contact').on('click', e => {
      e.preventDefault();
      u('#form-contact').removeClass('show');
    });

    u('textarea,input', '#form-contact').blur((e) => {
      const $input = u(e.currentTarget);
      if ($input.val() === '') {
        $input.removeClass('active');
      } else {
        $input.addClass('active');
      }
    });

    u('form', '#form-contact').on('submit', e => {
      e.preventDefault();
      u('button', '#form-contact').addClass('loading');

      u('.error,.success,label', '#form-contact').slideUp();
      u('.info', '#form-contact').slideDown();

      setTimeout(()=>{
        u('.info', '#form-contact').slideUp();

        if(Math.random() > 0.5) {
          u('.success', '#form-contact').slideDown();
          u('button', '#form-contact').fadeOut();
        } else {
          u('button', '#form-contact').removeClass('loading');
          u('.error, label', '#form-contact').slideDown();
        }

      }, 1500)
    });
  }
}
